import { Italian } from "flatpickr/dist/l10n/it.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Russian } from "flatpickr/dist/l10n/ru";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";

const SUPPORTED_BROWSERS_BOWSER_CONFIG = {
    chrome: ">=129",
    edge: ">=128",
    safari: ">=18",
};

const MIN_SUPPORTED_BROWSER_VERSIONS = {
    chrome: 129,
    edge: 128,
    safari: 18,
};

const FLATPICKR_LOCALES = {
    it: Italian,
    es: Spanish,
    fr: French,
    ru: Russian,
    ja: Japanese,
    zh: Mandarin,
    ko: Korean,
    ar: Arabic,
};

export {
    SUPPORTED_BROWSERS_BOWSER_CONFIG,
    MIN_SUPPORTED_BROWSER_VERSIONS,
    FLATPICKR_LOCALES,
};
